import { CheckCircle, PlusAddCircle, Clock, AlertErrorCircle } from '@/assets/icons'
import { FileAddDisposition, FileAddPreviewItem } from '../../store/schemas'

type DispositionDisplay = { text: string; className: string; Icon: typeof CheckCircle; blocking: boolean; loading?: boolean }

/**
 * Maps a preview disposition to its status treatment (icon + colored copy). FAILED_WILL_RETRY
 * is non-blocking — submitting re-extracts previously failed files. UNSUPPORTED_TYPE blocks:
 * the extraction pipeline cannot process the file at all.
 */
export function dispositionDisplay(item: FileAddPreviewItem | undefined): DispositionDisplay | null {
  if (!item) return null
  switch (item.disposition) {
    case FileAddDisposition.NEW:
      return { text: 'New file · Ready to process', className: 'text-green-800', Icon: PlusAddCircle, blocking: false }
    case FileAddDisposition.ALREADY_INCLUDED:
      return { text: 'In billing summary · This file will not be reprocessed', className: 'text-brand-neutral-600', Icon: CheckCircle, blocking: false }
    case FileAddDisposition.FAILED_WILL_RETRY:
      return { text: 'Failed previously · Will be retried', className: 'text-yellow-700', Icon: AlertErrorCircle, blocking: false }
    case FileAddDisposition.NOT_READY:
      return { text: 'Still processing · Wait for processing to finish', className: 'text-yellow-700', Icon: Clock, blocking: true, loading: true }
    case FileAddDisposition.NOT_IN_MATTER:
      return { text: 'Not available in this matter', className: 'text-red-700', Icon: AlertErrorCircle, blocking: true }
    case FileAddDisposition.UNSUPPORTED_TYPE:
      return { text: 'Unsupported file type', className: 'text-red-700', Icon: AlertErrorCircle, blocking: true }
  }
}
